/**
 * DNA Canvas Background
 */
(function () {
  function initDNACanvas(canvas) {
    var ctx = canvas.getContext('2d');
    var offset = 0;
    var time = 0;
    var raf;

    // Data packets — bright dots that travel along a strand
    var packets = [];
    for (var i = 0; i < 5; i++) {
      packets.push({
        x:      Math.random() * 1800,
        strand: i % 2,
        speed:  0.25 + Math.random() * 0.35,
        size:   1.8 + Math.random() * 1.4,
        alpha:  0.6 + Math.random() * 0.4
      });
    }

    function resize() {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    // Per-segment formation factor — two overlapping sine waves at irrational ratio
    // creates irregular regions of visibility (forming / dissolving feel)
    function formation(x, strandOffset) {
      var p = x * 0.016 + time * 0.18 + strandOffset;
      var f1 = Math.sin(p) * 0.5 + 0.5;
      var f2 = Math.sin(p * 1.618 + 1.3) * 0.5 + 0.5; // golden ratio keeps it non-repeating
      return f1 * f2; // 0 → 1, natural gaps appear and close
    }

    function draw() {
      var W    = canvas.width;
      var H    = canvas.height;
      var cy   = H / 2;
      var amp  = Math.min(H * 0.38, 140);
      var freq = 0.010;
      var step = 9; // rung spacing

      ctx.clearRect(0, 0, W, H);

      time   += 0.003;   // very slow — drives the form/break cycle
      offset += 0.003;   // slow horizontal drift

      // ── Strands ──────────────────────────────────────────────
      var segLen = 4;
      for (var s = 0; s < 2; s++) {
        var phaseShift = s === 0 ? 0 : Math.PI;
        var strandSeed = s * 3.7;

        for (var x = 0; x < W; x += segLen) {
          var ff = formation(x, strandSeed);
          if (ff < 0.15) continue; // gap — strand is broken here

          var y  = cy + amp * Math.sin(freq * x          + offset + phaseShift);
          var nx = x + segLen;
          var ny = cy + amp * Math.sin(freq * nx + offset + phaseShift);

          var alpha = Math.min(ff * 0.95, 0.88);

          ctx.beginPath();
          ctx.lineWidth   = 1.4 + ff * 1.8;
          ctx.strokeStyle = s === 0
            ? 'rgba(193,8,125,' + alpha + ')'
            : 'rgba(255,80,195,' + (alpha * 0.6) + ')';

          // glow only on well-formed segments
          if (ff > 0.65) {
            ctx.shadowColor = '#c1087d';
            ctx.shadowBlur  = 7;
          }
          ctx.moveTo(x, y);
          ctx.lineTo(nx, ny);
          ctx.stroke();
          ctx.shadowBlur = 0;
        }
      }

      // ── Rungs (base pairs) ────────────────────────────────────
      for (var rx = 0; rx <= W; rx += step) {
        var y1    = cy + amp * Math.sin(freq * rx + offset);
        var y2    = cy + amp * Math.sin(freq * rx + offset + Math.PI);
        var depth = Math.abs(Math.sin(freq * rx + offset)); // 0..1 depth cue

        // rungs use a slightly offset formation phase so they flicker independently
        var rf = formation(rx, 1.1);
        if (rf < 0.12) continue;

        var ra = rf * 0.7;

        // Rung line — dashed for digital feel
        ctx.setLineDash([3, 3]);
        ctx.lineDashOffset = -time * 18;
        ctx.beginPath();
        ctx.lineWidth   = 0.6 + depth * 0.9;
        ctx.strokeStyle = 'rgba(193,8,125,' + ra + ')';
        ctx.moveTo(rx, y1);
        ctx.lineTo(rx, y2);
        ctx.stroke();
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;

        // Diamond nodes at junction points (digital style)
        if (rf > 0.42) {
          var ns = (1.0 + depth * 2.2) * rf;

          ctx.save();
          ctx.translate(rx, y1);
          ctx.rotate(Math.PI / 4);
          ctx.fillStyle = 'rgba(255,110,205,' + Math.min(ra * 1.4, 0.9) + ')';
          if (rf > 0.7) { ctx.shadowColor = '#ff60c8'; ctx.shadowBlur = 5; }
          ctx.fillRect(-ns / 2, -ns / 2, ns, ns);
          ctx.shadowBlur = 0;
          ctx.restore();

          ctx.save();
          ctx.translate(rx, y2);
          ctx.rotate(Math.PI / 4);
          ctx.fillStyle = 'rgba(193,8,125,' + Math.min(ra * 1.4, 0.9) + ')';
          ctx.fillRect(-ns / 2, -ns / 2, ns, ns);
          ctx.restore();
        }
      }

      // ── Data packets ──────────────────────────────────────────
      for (var pi = 0; pi < packets.length; pi++) {
        var p  = packets[pi];
        p.x   += p.speed;
        if (p.x > W + 60) p.x = -60;

        var pPhase = p.strand === 0 ? 0 : Math.PI;
        var py = cy + amp * Math.sin(freq * p.x + offset + pPhase);

        // Only draw if the strand is formed at this position
        var pff = formation(p.x, p.strand * 3.7);
        if (pff < 0.2) continue;

        // Outer glow
        var gr = ctx.createRadialGradient(p.x, py, 0, p.x, py, p.size * 5);
        gr.addColorStop(0,   'rgba(255,180,235,' + (p.alpha * pff) + ')');
        gr.addColorStop(0.5, 'rgba(193,8,125,' + (0.35 * pff) + ')');
        gr.addColorStop(1,   'rgba(193,8,125,0)');
        ctx.beginPath();
        ctx.arc(p.x, py, p.size * 5, 0, Math.PI * 2);
        ctx.fillStyle = gr;
        ctx.fill();

        // Bright core
        ctx.beginPath();
        ctx.arc(p.x, py, p.size, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,210,245,' + (p.alpha * pff) + ')';
        ctx.fill();
      }

      raf = requestAnimationFrame(draw);
    }

    resize();
    window.addEventListener('resize', resize);
    draw();

    return function destroy() {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }

  function attachDNACanvases() {
    document.querySelectorAll('.cards .dna-canvas').forEach(function (canvas) {
      if (!canvas._dnaInit) {
        canvas._dnaInit = true;
        initDNACanvas(canvas);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachDNACanvases);
  } else {
    attachDNACanvases();
  }
})();

/**
 * Swirl Canvas — Content block top/bottom strips
 */
(function () {
  function initSwirlCanvas(canvas) {
    var ctx = canvas.getContext('2d');
    var time = 0;
    var raf;

    // Fast-moving particles spread across 5 wave streams spanning full height
    var streams = [0.12, 0.30, 0.50, 0.70, 0.88]; // vertical positions as fraction of H
    var particles = [];
    streams.forEach(function (vy, si) {
      for (var i = 0; i < 8; i++) {
        particles.push({
          x:       Math.random() * 2000,
          streamY: vy,
          speed:   1.2 + Math.random() * 1.8,
          size:    1.4 + Math.random() * 1.6,
          alpha:   0.5 + Math.random() * 0.5,
          stream:  si
        });
      }
    });

    function resize() {
      canvas.width  = canvas.offsetWidth;
      canvas.height = canvas.offsetHeight;
    }

    // Formation factor — same golden-ratio interference as DNA but faster phase
    function form(x, seed) {
      var p = x * 0.020 + time * 0.55 + seed;
      var f1 = Math.sin(p) * 0.5 + 0.5;
      var f2 = Math.sin(p * 1.618 + 0.9) * 0.5 + 0.5;
      return f1 * f2;
    }

    function draw() {
      var W = canvas.width;
      var H = canvas.height;

      ctx.clearRect(0, 0, W, H);

      time += 0.012; // ~4× faster than DNA

      var segLen = 4;

      // ── Wave streams ─────────────────────────────────────────
      streams.forEach(function (vy, si) {
        var cy  = H * vy;
        var amp = H * 0.07; // gentle swing — streams stay in their lanes across the full height
        var freq = 0.018 + si * 0.004; // slightly different freq per stream
        var phaseOff = si * 1.1;

        // Cross-link: draw faint connectors between adjacent streams
        if (si < streams.length - 1) {
          var cy2   = H * streams[si + 1];
          var freq2 = 0.018 + (si + 1) * 0.004;
          var phOff2 = (si + 1) * 1.1;

          for (var lx = 0; lx < W; lx += 14) {
            var ly1 = cy  + amp * Math.sin(freq  * lx + time * 2.2 + phaseOff);
            var ly2 = cy2 + amp * Math.sin(freq2 * lx + time * 2.2 + phOff2);
            var lf  = form(lx, si * 2.3 + 5);
            if (lf < 0.2) continue;
            ctx.beginPath();
            ctx.lineWidth   = 0.5;
            ctx.strokeStyle = 'rgba(193,8,125,' + (lf * 0.22) + ')';
            ctx.moveTo(lx, ly1);
            ctx.lineTo(lx, ly2);
            ctx.stroke();
          }
        }

        // Wave line — drawn segment by segment with formation gaps
        for (var x = 0; x < W; x += segLen) {
          var ff = form(x, si * 2.7);
          if (ff < 0.14) continue;

          var y  = cy + amp * Math.sin(freq * x          + time * 2.2 + phaseOff);
          var nx = x + segLen;
          var ny = cy + amp * Math.sin(freq * nx + time * 2.2 + phaseOff);

          var alpha = Math.min(ff * 0.9, 0.85);

          ctx.beginPath();
          ctx.lineWidth   = 1.0 + ff * 1.4;
          // Alternate between two pink shades per stream
          ctx.strokeStyle = (si % 2 === 0)
            ? 'rgba(193,8,125,' + alpha + ')'
            : 'rgba(255,80,195,' + (alpha * 0.7) + ')';

          if (ff > 0.68) { ctx.shadowColor = '#c1087d'; ctx.shadowBlur = 5; }
          ctx.moveTo(x, y);
          ctx.lineTo(nx, ny);
          ctx.stroke();
          ctx.shadowBlur = 0;
        }

        // Diamond nodes at regular intervals
        for (var dx = 0; dx < W; dx += 20) {
          var nff = form(dx, si * 2.7 + 0.8);
          if (nff < 0.4) continue;
          var depth = Math.abs(Math.sin(freq * dx + time * 2.2 + phaseOff));
          var ny2   = cy + amp * Math.sin(freq * dx + time * 2.2 + phaseOff);
          var ns    = (0.8 + depth * 1.6) * nff;

          ctx.save();
          ctx.translate(dx, ny2);
          ctx.rotate(Math.PI / 4);
          ctx.fillStyle = 'rgba(255,110,205,' + Math.min(nff * 0.95, 0.9) + ')';
          if (nff > 0.7) { ctx.shadowColor = '#ff60c8'; ctx.shadowBlur = 4; }
          ctx.fillRect(-ns / 2, -ns / 2, ns, ns);
          ctx.shadowBlur = 0;
          ctx.restore();
        }
      });

      // ── Particles ─────────────────────────────────────────────
      for (var pi = 0; pi < particles.length; pi++) {
        var p    = particles[pi];
        p.x     += p.speed;
        if (p.x > W + 60) p.x = -60;

        var si2   = p.stream;
        var cy3   = H * p.streamY;
        var amp3  = H * 0.07;
        var freq3 = 0.018 + si2 * 0.004;
        var ph3   = si2 * 1.1;
        var py    = cy3 + amp3 * Math.sin(freq3 * p.x + time * 2.2 + ph3);

        var pff = form(p.x, si2 * 2.7);
        if (pff < 0.2) continue;

        var pa = p.alpha * pff;

        // Glow halo
        var gr = ctx.createRadialGradient(p.x, py, 0, p.x, py, p.size * 6);
        gr.addColorStop(0,   'rgba(255,180,235,' + pa + ')');
        gr.addColorStop(0.4, 'rgba(193,8,125,'   + (pa * 0.5) + ')');
        gr.addColorStop(1,   'rgba(193,8,125,0)');
        ctx.beginPath();
        ctx.arc(p.x, py, p.size * 6, 0, Math.PI * 2);
        ctx.fillStyle = gr;
        ctx.fill();

        // Bright core
        ctx.beginPath();
        ctx.arc(p.x, py, p.size, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(255,215,245,' + pa + ')';
        ctx.fill();
      }

      raf = requestAnimationFrame(draw);
    }

    resize();
    window.addEventListener('resize', resize);
    draw();

    return function destroy() {
      cancelAnimationFrame(raf);
      window.removeEventListener('resize', resize);
    };
  }

  function attachSwirlCanvases() {
    document.querySelectorAll('.content-block .swirl-canvas').forEach(function (canvas) {
      if (!canvas._swirlInit) {
        canvas._swirlInit = true;
        initSwirlCanvas(canvas);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attachSwirlCanvases);
  } else {
    attachSwirlCanvases();
  }
})();

jQuery(function ($) {

  // GATE-36: scroll reveal, replacing the animate-on-scroll library.
  //
  // the old library's trigger point was `offset: 120` — it fires when the element's top is
  // 120px above the viewport bottom. The IntersectionObserver equivalent is a
  // negative bottom rootMargin, which shrinks the root by the same 120px.
  //
  // ONE-SHOT, and this is a deliberate DEPARTURE from the animate-on-scroll library, not parity with it.
  // its default was `once: false` — measured, not assumed: scrolling an
  // animated element back out of view removes its state class and returns it to
  // opacity 0, so the copy fades away again on the way back up. That is the
  // behaviour being replaced, not preserved. `unobserve` after the first
  // reveal means content revealed stays revealed.
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;

    // Per-element timing, read from the attributes and written as custom
    // properties so the CSS stays a single rule. Done for every element up
    // front, before anything can transition.
    for (var i = 0; i < els.length; i++) {
      var d = els[i].getAttribute('data-reveal-duration');
      var w = els[i].getAttribute('data-reveal-delay');
      if (d) els[i].style.setProperty('--reveal-duration', parseInt(d, 10) + 'ms');
      if (w) els[i].style.setProperty('--reveal-delay', parseInt(w, 10) + 'ms');
    }

    var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // No observer support, or the visitor asked for less motion: reveal
    // everything at once. The CSS already neutralises the transform under the
    // media query; this makes sure the state class is on regardless.
    if (reduced || !('IntersectionObserver' in window)) {
      for (var j = 0; j < els.length; j++) els[j].classList.add('is-revealed');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      for (var k = 0; k < entries.length; k++) {
        if (!entries[k].isIntersecting) continue;
        entries[k].target.classList.add('is-revealed');
        io.unobserve(entries[k].target);
      }
    }, { rootMargin: '0px 0px -120px 0px' });

    for (var m = 0; m < els.length; m++) io.observe(els[m]);
  }

  $(document).ready(initReveal);

  /**
   * Card Expand Behaviour
   */
  $(document).ready(function() {
    // Get all toggle buttons
    const $toggleButtons = $('.toggle-btn');
    
    // Add click event listener to each toggle button
    $toggleButtons.on('click', function(e) {
      e.preventDefault();
      
      // Get the parent service card
      const $serviceCard = $(this).closest('.service-card');
      const $card = $(this).closest('.card');
      
      // Toggle the expanded class
      $serviceCard.toggleClass('expanded');
      $card.toggleClass('expanded');

      // Update aria-expanded attribute for accessibility
      const isExpanded = $serviceCard.hasClass('expanded');
      const isCardExpanded = $card.hasClass('expanded');
      $(this).attr('aria-expanded', isExpanded || isCardExpanded);

      // Scroll to card on expand — done here in the click handler, no polling needed
      if (isExpanded || isCardExpanded) {
        const $target = $serviceCard.length ? $serviceCard : $card;
        setTimeout(function() {
          $('html, body').animate({ scrollTop: $target.offset().top - 100 }, 500, 'swing');
        }, 100);
      }
      
      // Optional: Close other cards when one is opened (uncomment if desired)
      // if (isExpanded) {
      //     $toggleButtons.each(function() {
      //         if (this !== $serviceCard.find('.toggle-btn')[0]) {
      //             const $otherCard = $(this).closest('.service-card');
      //             $otherCard.removeClass('expanded');
      //             $(this).attr('aria-expanded', 'false');
      //         }
      //     });
      // }
    });
    
    // Initialize aria-expanded attribute
    $toggleButtons.attr('aria-expanded', 'false');
    
    // Add keyboard support for accessibility
    $toggleButtons.on('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        $(this).trigger('click');
      }
    });
    
  });
  
  // Optional: Add intersection observer for animation on scroll using jQuery
  const animateOnScroll = function() {
    const $cards = $('.service-card');
    
    // Set initial state
    $cards.css({
      'opacity': '0',
      'transform': 'translateY(30px)',
      'transition': 'opacity 0.6s ease, transform 0.6s ease'
    });
    
    // Check if Intersection Observer is supported
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            $(entry.target).css({
              'opacity': '1',
              'transform': 'translateY(0)'
            });
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      
      $cards.each(function() {
        observer.observe(this);
      });
    } else {
      // Fallback for browsers without Intersection Observer
      $(window).on('scroll resize', function() {
        const windowTop = $(window).scrollTop();
        const windowHeight = $(window).height();
        
        $cards.each(function() {
          const $card = $(this);
          const cardTop = $card.offset().top;
          
          if (cardTop < windowTop + windowHeight - 50) {
            $card.css({
              'opacity': '1',
              'transform': 'translateY(0)'
            });
          }
        });
      });
      
      // Trigger initial check
      $(window).trigger('scroll');
    }
  };
  
  // Initialize scroll animations
  $(document).ready(function() {
    animateOnScroll();
  });

  /**
   * Accordion
   */
  $(document).ready(function() {
    $('.accordion-toggle').on('click', function() {
      var $item = $(this).parent('.accordion-item');
  
      // toggle active state
      $item.toggleClass('active');
  
      // optional: close others when one is open (accordion behavior)
      // $item.siblings().removeClass('active');
    });
  });

/**
 * Slider
 *
 * FIX-02: this used to select one hardcoded carousel id (see slider.php).
 * Every slider block emitted that same id, so on a page with two blocks the
 * jQuery selector matched only the first — the second carousel was never
 * initialised, never got swipe support, and its indicators and arrows drove
 * the first block instead.
 *
 * Each carousel is now found by class and initialised against its own root,
 * with its own swipe state. Nothing here references an id at all, so the
 * generated ids in slider.php only have to satisfy Bootstrap's own
 * data-bs-target lookup.
 */
$(document).ready(function() {
  $('.slider .carousel').each(function() {
    const $carousel = $(this);

    // House convention: guard against double-initialisation.
    if ($carousel.attr('data-crafted-carousel-init')) {
      return;
    }
    $carousel.attr('data-crafted-carousel-init', 'true');

    // FIX-04: the interval used to be hardcoded to 5000 here while slider.php
    // wrote data-bs-interval from the ACF autoplay_interval field, and 'false'
    // when autoplay was off. Which of the two applied was NOT deterministic:
    // Bootstrap's data-api auto-initialises anything with
    // data-bs-ride="carousel" on DOMContentLoaded, and the jQuery interface
    // goes through getOrCreateInstance(), which returns an EXISTING instance
    // and discards the config passed to it. So if the data-api won the race the
    // ACF value applied; if this ran first, 5000 did. The editor's setting
    // worked or did not work depending on load order.
    //
    // Deriving the config from the same data attributes the data-api reads
    // makes both paths agree, so the ACF value wins either way.
    const rawInterval = $carousel.attr('data-bs-interval');
    let interval;
    if (rawInterval === undefined) {
      interval = 5000;            // Bootstrap's own default, matched explicitly
    } else if (rawInterval === 'false') {
      interval = false;           // autoplay off — do not cycle
    } else {
      const parsed = parseInt(rawInterval, 10);
      interval = (isFinite(parsed) && parsed > 0) ? parsed : false;
    }

    $carousel.carousel({
      interval: interval,
      wrap: true,     // Loop back to first slide (Bootstrap's default)
      pause: 'hover'  // Pause on hover (Bootstrap's default)
    });

    // Add smooth transition effects
    $carousel.on('slide.bs.carousel', function (e) {
      // Optional: Add custom transition effects here.
      // jQuery allows you to easily select elements within the event context.
      const activeItem = $(e.target).find('.carousel-item.active');
      const nextItem = $(e.relatedTarget);

      console.log('Sliding from slide', e.from, 'to slide', e.to);
    });

    // Touch/swipe support for mobile. startX is per carousel — a shared
    // variable would let a swipe started on one block finish on another.
    let startX = 0;

    $carousel.on('touchstart', function(e) {
      startX = e.originalEvent.touches[0].clientX;
    });

    $carousel.on('touchend', function(e) {
      const endX = e.originalEvent.changedTouches[0].clientX;
      const threshold = 50; // Minimum swipe distance
      const diff = startX - endX;

      if (Math.abs(diff) > threshold) {
        if (diff > 0) {
          $carousel.carousel('next'); // Swipe left - next slide
        } else {
          $carousel.carousel('prev'); // Swipe right - previous slide
        }
      }
    });
  });

  // No click handler on .carousel-btn. There used to be one — scaffolding that
  // called e.preventDefault() and then alert('Button clicked! Add your custom
  // functionality here.'). .carousel-btn is the class on the slide's <a href>,
  // so that handler cancelled the navigation on every slider CTA on the site
  // and showed a placeholder alert instead. The link is the behaviour; it needs
  // no JS. Do not reintroduce a delegated handler on this class.

  // Arrow-key navigation is Bootstrap's own (`keyboard: true`, on by default),
  // which binds keydown to each carousel element and so is already per
  // instance. The handler removed here was bound to `document` and closed over
  // one carousel: with two blocks on a page it drove the wrong one, and it
  // fired while the visitor was typing in a form field elsewhere on the page.
  // There is no way to scope a document-level handler to a root, which is what
  // this fix requires.
});

$(document).ready(function() {
  // Function to handle scroll events
  function handleScroll() {
      // Check if user has scrolled more than 100px
      if ($(window).scrollTop() > 100) {
          $('.site-header').addClass('scrolled');
      } else {
          $('.site-header').removeClass('scrolled');
      }
  }
  
  // Add scroll event listener
  $(window).on('scroll', handleScroll);
  
  // Optional: Throttle scroll events for better performance
  let ticking = false;
  
  function optimizedScroll() {
      if (!ticking) {
          requestAnimationFrame(function() {
              handleScroll();
              ticking = false;
          });
          ticking = true;
      }
  }
  
  // Use the optimized version (comment out the above scroll handler and uncomment this)
  // $(window).on('scroll', optimizedScroll);
});

/**
 * Projects Slider
 *
 * FIX-03: this used to bind ten hardcoded ids. Two projects blocks on a page
 * shared every one of them, and the damage went past the selectors:
 *
 *   - the project array was gathered from a document-wide selector, so the
 *     second block's projects were appended to the first block's list;
 *   - currentIndex was one closure variable, so both blocks shared a position;
 *   - the prev/next buttons resolved to the first block only, leaving the
 *     second block's arrows dead.
 *
 * Each `.projects` root is now initialised against itself, with its own array,
 * its own index, its own track, buttons and details panel. Structural elements
 * are found by the classes they already carried; the six elements written into
 * carry a `data-project-slot` name. Nothing here selects an id.
 */
$(document).ready(function() {
  $('.projects').each(function() {
    const $block = $(this);

    // House convention: guard against double-initialisation.
    if ($block.attr('data-projects-init')) {
      return;
    }
    $block.attr('data-projects-init', 'true');

    // Retrieve project data from the data-* attributes on this block's images.
    const projects = [];
    $block.find('.g-carousel-item img').each(function() {
        const $img = $(this);
        projects.push({
            top_content: $img.data('project-top-content'),
            description: $img.data('project-desc'),
            link: $img.data('project-link'),
            linkText: $img.data('project-link-text'),
            type: $img.data('project-type'),
            sector: $img.data('project-sector'),
            technology: $img.data('project-technology')
        });
    });

    // Per block, not globally — an empty block must not stop a later one
    // initialising.
    if ( projects.length === 0 ) return;

    let currentIndex = 0;
    const $carouselTrack = $block.find('.g-carousel-track');
    const $prevBtn = $block.find('.g-prev');
    const $nextBtn = $block.find('.g-next');
    const $projectDetails = $block.find('.g-project-details');

    // Every write target is resolved inside this block's subtree.
    function slot(name) {
        return $block.find('[data-project-slot="' + name + '"]');
    }

    // Function to update the left content based on the current index
    function updateContent(index, immediate) {
        const project = projects[index];

        function apply() {
            slot('top-content').html(project.top_content);
            slot('desc').text(project.description);
            slot('link').text(project.link).attr('href', project.link);
            slot('type').text(project.type);
            slot('sector').text(project.sector);
            slot('technology').text(project.technology);

            $projectDetails.css('opacity', '1');
        }

        // SEO-07: the panel now arrives from the server already holding project
        // 0's content. Fading it out and rewriting it 300ms later would blank
        // visible copy and then restore the identical text — a flash with no
        // purpose. On the first call, write through with no delay; the values
        // are the same ones the markup already carries, so nothing moves.
        if (immediate) {
            apply();
            return;
        }

        // Animate the content fade-out
        $projectDetails.css('opacity', '0');

        // After a short delay, update the content and fade it back in
        setTimeout(apply, 300); // Match the CSS transition duration
    }

    // Function to move the carousel to the next slide
    function nextSlide() {
        currentIndex = (currentIndex + 1) % projects.length;
        updateCarousel();
    }

    // Function to move the carousel to the previous slide
    function prevSlide() {
        currentIndex = (currentIndex - 1 + projects.length) % projects.length;
        updateCarousel();
    }

    // Function to update the carousel's visual state and the left content
    function updateCarousel() {
        const offset = -currentIndex * 100;
        $carouselTrack.css('transform', `translateX(${offset}%)`);
        updateContent(currentIndex);
    }

    // Event listeners for the navigation buttons
    $nextBtn.on('click', nextSlide);
    $prevBtn.on('click', prevSlide);

    // Initial call to set up the first slide and content. `immediate` — see
    // updateContent(): the server already rendered this project (SEO-07).
    updateContent(currentIndex, true);
  });
});

/**
 * Scroll to Top Button
 */
// Wait for the document to be fully loaded
$(document).ready(function() {

  // Get the button element
  const scrollToTopBtn = $('#scrollToTopBtn');

  // Show or hide the button based on scroll position
  $(window).scroll(function() {
    // Check if the user has scrolled more than 800px from the top
    if ($(this).scrollTop() > 800) {
      scrollToTopBtn.fadeIn(); // Use a nice fade-in effect
    } else {
      scrollToTopBtn.fadeOut(); // Use a fade-out effect
    }
  });

  // Smooth scroll to top when the button is clicked
  scrollToTopBtn.click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 800); // 800 milliseconds for the animation speed
    return false; // Prevent default click action
  });

});

/**
 * Scrolling Cards Navigation
 */
$(document).ready(function() {
  const $container = $('.scrolling-container');
  const $wrapper = $('.scrolling-wrapper');
  const $cards = $('.scrolling-card');
  const $prevBtn = $('.scrolling-nav-arrow.prev');
  const $nextBtn = $('.scrolling-nav-arrow.next');
  const $dots = $('.scrolling-nav-dot');
  
  if (!$container.length || !$wrapper.length || !$cards.length) return;
  
  let currentIndex = 0;
  const cardWidth = $cards.first().outerWidth(true);
  const totalCards = $cards.length;
  
  // Function to update carousel position
  function updateCarousel() {
    const offset = -currentIndex * cardWidth;
    $wrapper.css('transform', `translateX(${offset}px)`);
    
    // Update dots
    $dots.removeClass('active');
    $dots.eq(currentIndex).addClass('active');
    
    // Update button states
    $prevBtn.toggleClass('disabled', currentIndex === 0);
    $nextBtn.toggleClass('disabled', currentIndex === totalCards - 1);
  }
  
  // Navigation functions
  function nextCard() {
    if (currentIndex < totalCards - 1) {
      currentIndex++;
      updateCarousel();
    }
  }
  
  function prevCard() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  }
  
  function goToCard(index) {
    if (index >= 0 && index < totalCards) {
      currentIndex = index;
      updateCarousel();
    }
  }
  
  // Event listeners
  $nextBtn.on('click', nextCard);
  $prevBtn.on('click', prevCard);
  
  // Dot navigation
  $dots.on('click', function() {
    const dotIndex = $(this).index();
    goToCard(dotIndex);
  });
  
  // Keyboard navigation
  $(document).on('keydown', function(e) {
    if ($container.is(':visible')) {
      if (e.key === 'ArrowLeft') {
        prevCard();
      } else if (e.key === 'ArrowRight') {
        nextCard();
      }
    }
  });
  
  // Touch/swipe support
  let startX = 0;
  let endX = 0;
  
  $container.on('touchstart', function(e) {
    startX = e.originalEvent.touches[0].clientX;
  });
  
  $container.on('touchend', function(e) {
    endX = e.originalEvent.changedTouches[0].clientX;
    handleSwipe();
  });
  
  function handleSwipe() {
    const threshold = 50;
    const diff = startX - endX;
    
    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        nextCard(); // Swipe left - next card
      } else {
        prevCard(); // Swipe right - previous card
      }
    }
  }
  
  // Initialize
  updateCarousel();
  
  // Handle resize
  $(window).on('resize', function() {
    const newCardWidth = $cards.first().outerWidth(true);
    const offset = -currentIndex * newCardWidth;
    $wrapper.css('transform', `translateX(${offset}px)`);
  });
});

/**
 * Cards Expandable — row-drawer pattern
 * Cards stay in their grid positions. A full-width detail drawer
 * slides open below the row of the clicked card.
 */
$(document).ready(function() {
  const $cardSection = $('.card-expandeables');
  if (!$cardSection.length) return;

  const $grid       = $cardSection.find('#cardGrid');
  const $drawer     = $('<div class="card-detail-drawer" role="region" aria-live="polite"></div>');
  let   $activeCard = null;

  // Find all cards that share the same grid row as $card (same offsetTop ±5px)
  function getRowCards($card) {
    const top = $card.offset().top;
    return $grid.find('.expandablecard').filter(function() {
      return Math.abs($(this).offset().top - top) < 5;
    });
  }

  function closeDrawer(cb) {
    $drawer.addClass('closing');
    setTimeout(function() {
      $drawer.removeClass('is-open closing').detach();
      if ($activeCard) { $activeCard.removeClass('active'); $activeCard = null; }
      if (cb) cb();
    }, 380);
  }

  function openDrawer($card) {
    const title   = $card.find('.card-title').text();
    const content = $card.find('.card-long-description').html();

    $drawer.html(
      '<div class="cdd-inner">' +
        '<div class="cdd-header">' +
          '<h3 class="cdd-title">' + title + '</h3>' +
          '<button class="cdd-close" aria-label="Close detail">' +
            '<span aria-hidden="true">&#x2715;</span>' +
          '</button>' +
        '</div>' +
        '<div class="cdd-body">' + content + '</div>' +
      '</div>'
    );

    // Insert after last card in same row
    const $rowCards  = getRowCards($card);
    const $lastInRow = $rowCards.last();
    $drawer.removeClass('is-open closing').insertAfter($lastInRow);

    // Force reflow, then animate open
    $drawer[0].offsetHeight;
    $drawer.addClass('is-open');

    // Scroll so drawer top is just below the fixed nav (~100px offset)
    setTimeout(function() {
      $('html, body').animate({
        scrollTop: $drawer.offset().top - 110
      }, 480, 'swing');
    }, 60);
  }

  // Card click
  $cardSection.on('click', '.expandablecard', function() {
    const $clicked = $(this);

    if ($activeCard && $activeCard.is($clicked)) {
      // Same card — close
      closeDrawer();
      return;
    }

    if ($drawer.parent().length) {
      // Different card already open — close then reopen
      closeDrawer(function() {
        $activeCard = $clicked;
        $clicked.addClass('active');
        openDrawer($clicked);
      });
    } else {
      $activeCard = $clicked;
      $clicked.addClass('active');
      openDrawer($clicked);
    }
  });

  // Close button inside drawer
  $cardSection.on('click', '.cdd-close', function(e) {
    e.stopPropagation();
    closeDrawer();
  });

  // Re-position drawer on resize (row layout may change)
  var resizeTimer;
  $(window).on('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      if ($activeCard && $drawer.parent().length) {
        const $rowCards  = getRowCards($activeCard);
        const $lastInRow = $rowCards.last();
        $drawer.insertAfter($lastInRow);
      }
    }, 150);
  });
});

});

// ─────────────────────────────────────────────────────────────────────────────
// v2-services-cards — tilt hover effect
// Reads mouse position over each [data-v2-tilt] card and writes --v2-tilt-x/y
// CSS custom properties so SCSS can apply the perspective transform.
// ─────────────────────────────────────────────────────────────────────────────

(function () {

    var MAX_TILT = 8; // degrees

    function initV2ServicesTilt() {
        var grids = document.querySelectorAll('[data-v2-hover="tilt"]');
        if (!grids.length) return;

        grids.forEach(function (grid) {
            if (grid.dataset.v2Init === 'true') return;
            grid.dataset.v2Init = 'true';

            grid.querySelectorAll('[data-v2-tilt]').forEach(function (card) {
                card.addEventListener('mousemove', function (e) {
                    var rect = card.getBoundingClientRect();
                    var x    = e.clientX - rect.left;
                    var y    = e.clientY - rect.top;
                    var rx   = ((y / rect.height) - 0.5) * -MAX_TILT * 2;
                    var ry   = ((x / rect.width)  - 0.5) *  MAX_TILT * 2;
                    card.style.setProperty('--v2-tilt-x', rx.toFixed(2) + 'deg');
                    card.style.setProperty('--v2-tilt-y', ry.toFixed(2) + 'deg');
                }, { passive: true });

                card.addEventListener('mouseleave', function () {
                    card.style.setProperty('--v2-tilt-x', '0deg');
                    card.style.setProperty('--v2-tilt-y', '0deg');
                });
            });
        });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2ServicesTilt);
    } else {
        initV2ServicesTilt();
    }

})();
(function () {

    // v2-highlight-reel-marquee
    // PHP renders items twice for the -50% loop. If one set is narrower than
    // the viewport we clone items until it fills, keeping 2 equal halves.
    function fillTrack(track) {
        var children = Array.from(track.children);
        var halfLen  = Math.floor(children.length / 2);
        if (halfLen < 1) return;

        // scrollWidth = 2 sets rendered by PHP; one set = half that
        var setWidth = track.scrollWidth / 2;
        if (setWidth <= 0) return;

        var needed = Math.ceil(window.innerWidth / setWidth);
        if (needed <= 1) return; // already fills viewport

        var originals = children.slice(0, halfLen);

        // Rebuild: [originals × needed] × 2 so -50% still = exactly one set
        track.innerHTML = '';
        for (var pass = 0; pass < 2; pass++) {
            for (var rep = 0; rep < needed; rep++) {
                originals.forEach(function (item) {
                    track.appendChild(item.cloneNode(true));
                });
            }
        }
    }

    function initV2HighlightReelMarquee() {
        var sections = document.querySelectorAll('.v2-highlight-reel-marquee');
        if (!sections.length) return;

        sections.forEach(function (section) {
            section.querySelectorAll('.v2-highlight-reel-marquee__track').forEach(fillTrack);
        });

        var resizeTimer;
        window.addEventListener('resize', function () {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function () {
                sections.forEach(function (section) {
                    section.querySelectorAll('.v2-highlight-reel-marquee__track').forEach(function (track) {
                        track.style.animationPlayState = 'paused';
                        void track.offsetWidth;
                        track.style.animationPlayState = '';
                    });
                });
            }, 200);
        }, { passive: true });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2HighlightReelMarquee);
    } else {
        initV2HighlightReelMarquee();
    }

})();

(function () {

    // Shared count-up animation for v2-horizontal-stats and v2-stats-bar
    // IntersectionObserver fires once per section; easeOutCubic easing.

    function easeOutCubic(t) {
        return 1 - Math.pow(1 - t, 3);
    }

    function animateValue(el) {
        // FIX-01: stat_value is free text, so it may be "50+", "10+Years" or empty.
        // PHP renders those as typed; parseFloat would truncate to 50 / 10 / 0 and
        // this function overwrites textContent, silently destroying the editor's text.
        // Leave anything that isn't a plain number exactly as the server rendered it.
        if (!/^-?\d+(\.\d+)?$/.test((el.dataset.target || '').trim())) return;

        var target   = parseFloat(el.dataset.target)   || 0;
        var suffix   = el.dataset.suffix               || '';
        var decimal  = parseInt(el.dataset.decimal, 10) || 0;
        var duration = parseInt(el.dataset.duration, 10) || 1800;
        var start    = null;

        function step(ts) {
            if (!start) start = ts;
            var elapsed  = ts - start;
            var progress = Math.min(elapsed / duration, 1);
            var eased    = easeOutCubic(progress);
            var current  = eased * target;
            el.textContent = current.toFixed(decimal) + suffix;
            if (progress < 1) requestAnimationFrame(step);
        }

        requestAnimationFrame(step);
    }

    function initV2StatCountUp() {
        var sections = document.querySelectorAll('.v2-horizontal-stats, .v2-stats-bar');
        if (!sections.length) return;

        if (!('IntersectionObserver' in window)) {
            // Fallback: just show final values (already in HTML)
            return;
        }

        var animated = new Set();

        var observer = new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                var section = entry.target;
                if (animated.has(section)) return;
                animated.add(section);
                observer.unobserve(section);
                section.querySelectorAll('[data-target]').forEach(animateValue);
            });
        }, { threshold: 0.25 });

        sections.forEach(function (section) {
            observer.observe(section);
        });
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2StatCountUp);
    } else {
        initV2StatCountUp();
    }

})();

(function () {

    // v2-faq-accordion — accessible accordion with single/multi open support

    function initV2FaqAccordion() {
        var sections = document.querySelectorAll('.v2-faq-accordion');
        if (!sections.length) return;

        sections.forEach(function (section) {
            var behaviour = section.dataset.openBehaviour || 'single';
            var items     = section.querySelectorAll('.v2-faq-accordion__item');

            items.forEach(function (item) {
                var btn    = item.querySelector('.v2-faq-accordion__q');
                var answer = item.querySelector('.v2-faq-accordion__a');
                if (!btn || !answer) return;

                btn.addEventListener('click', function () {
                    var isOpen = item.classList.contains('v2-faq-accordion__item--open');

                    if (behaviour === 'single' && !isOpen) {
                        items.forEach(function (other) {
                            if (other === item) return;
                            closeItem(other);
                        });
                    }

                    if (isOpen) {
                        closeItem(item);
                    } else {
                        openItem(item);
                    }
                });
            });
        });
    }

    function openItem(item) {
        var btn    = item.querySelector('.v2-faq-accordion__q');
        var answer = item.querySelector('.v2-faq-accordion__a');
        item.classList.add('v2-faq-accordion__item--open');
        if (btn)    btn.setAttribute('aria-expanded', 'true');
        if (answer) answer.setAttribute('aria-hidden', 'false');
    }

    function closeItem(item) {
        var btn    = item.querySelector('.v2-faq-accordion__q');
        var answer = item.querySelector('.v2-faq-accordion__a');
        item.classList.remove('v2-faq-accordion__item--open');
        if (btn)    btn.setAttribute('aria-expanded', 'false');
        if (answer) answer.setAttribute('aria-hidden', 'true');
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2FaqAccordion);
    } else {
        initV2FaqAccordion();
    }

})();

(function () {

    function initV2PortfolioSlider() {
        var sections = document.querySelectorAll('.v2-portfolio-slider');
        if (!sections.length) return;

        sections.forEach(function (section) {
            var track   = section.querySelector('.v2-portfolio-slider__track');
            var slides  = section.querySelectorAll('.v2-portfolio-slider__slide');
            var dots    = section.querySelectorAll('.v2-portfolio-slider__dot');
            var prevBtn = section.querySelector('.v2-portfolio-slider__arrow--prev');
            var nextBtn = section.querySelector('.v2-portfolio-slider__arrow--next');
            var total   = slides.length;
            var cur     = 0;

            if (!track || !total) return;

            function goTo(idx) {
                idx = Math.max(0, Math.min(idx, total - 1));
                cur = idx;

                track.style.transform = 'translateX(-' + (cur * 100) + '%)';

                slides.forEach(function (s, i) {
                    s.setAttribute('aria-hidden', i !== cur ? 'true' : 'false');
                });

                dots.forEach(function (d, i) {
                    var isActive = i === cur;
                    d.classList.toggle('v2-portfolio-slider__dot--active', isActive);
                    d.setAttribute('aria-selected', isActive ? 'true' : 'false');
                });

                if (prevBtn) prevBtn.disabled = cur === 0;
                if (nextBtn) nextBtn.disabled = cur === total - 1;
            }

            dots.forEach(function (dot) {
                dot.addEventListener('click', function () {
                    goTo(parseInt(dot.dataset.index, 10));
                });
            });

            if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
            if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });

            var touchStartX = null;
            track.addEventListener('touchstart', function (e) {
                touchStartX = e.touches[0].clientX;
            }, { passive: true });

            track.addEventListener('touchend', function (e) {
                if (touchStartX === null) return;
                var diff = touchStartX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) goTo(diff > 0 ? cur + 1 : cur - 1);
                touchStartX = null;
            }, { passive: true });

            section.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowLeft')  goTo(cur - 1);
                if (e.key === 'ArrowRight') goTo(cur + 1);
            });

            goTo(0);
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2PortfolioSlider);
    } else {
        initV2PortfolioSlider();
    }

})();

// ─────────────────────────────────────────────────────────────
// v2-tech-stack-grid — category filter
// ─────────────────────────────────────────────────────────────
(function () {

    function initV2TechStackGrid() {
        var sections = document.querySelectorAll('.v2-tech-stack-grid');
        if (!sections.length) return;

        sections.forEach(function (section) {
            var catBtns = section.querySelectorAll('.v2-tech-stack-grid__cat');
            var cards   = section.querySelectorAll('.v2-tech-stack-grid__card');

            if (!catBtns.length) return;

            catBtns.forEach(function (btn) {
                btn.addEventListener('click', function () {
                    var cat = btn.dataset.cat;

                    // Update active tab
                    catBtns.forEach(function (b) {
                        b.classList.remove('v2-tech-stack-grid__cat--active');
                        b.setAttribute('aria-selected', 'false');
                    });
                    btn.classList.add('v2-tech-stack-grid__cat--active');
                    btn.setAttribute('aria-selected', 'true');

                    // Filter cards
                    cards.forEach(function (card) {
                        if (cat === 'all' || card.dataset.cat === cat) {
                            card.classList.remove('v2-tech-stack-grid__card--hidden');
                        } else {
                            card.classList.add('v2-tech-stack-grid__card--hidden');
                        }
                    });
                });
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2TechStackGrid);
    } else {
        initV2TechStackGrid();
    }

})();

// ─────────────────────────────────────────────────────────────
// v2-testimonials-cards — responsive slider
// ─────────────────────────────────────────────────────────────
(function () {

    var AVATAR_COLOURS = [
        { bg: 'rgba(193,8,125,.15)',   border: 'rgba(193,8,125,.3)',   text: '#c1087d' },
        { bg: 'rgba(60,137,201,.15)',  border: 'rgba(60,137,201,.3)',  text: '#3c89c9' },
        { bg: 'rgba(128,200,192,.15)', border: 'rgba(128,200,192,.3)', text: '#80c8c0' },
        { bg: 'rgba(118,35,120,.15)',  border: 'rgba(118,35,120,.3)',  text: '#762378' },
    ];

    function initV2TestimonialsCards() {
        var sections = document.querySelectorAll('.v2-testimonials-cards');
        if (!sections.length) return;

        sections.forEach(function (section) {
            if (section.dataset.v2Init) return;
            section.dataset.v2Init = '1';

            var track   = section.querySelector('.v2-testimonials-cards__track');
            var slides  = section.querySelectorAll('.v2-testimonials-cards__slide');
            var dots    = section.querySelectorAll('.v2-testimonials-cards__dot');
            var prevBtn = section.querySelector('.v2-testimonials-cards__arrow--prev');
            var nextBtn = section.querySelector('.v2-testimonials-cards__arrow--next');
            var total   = slides.length;
            var vis     = parseInt(section.dataset.visible, 10) || 2;
            var cur     = 0;

            if (!track || !total) return;

            // Colour initials avatars via cycling palette
            section.querySelectorAll('.v2-testimonials-cards__avatar--initials').forEach(function (el, i) {
                var c = AVATAR_COLOURS[i % AVATAR_COLOURS.length];
                el.style.background  = c.bg;
                el.style.borderColor = c.border;
                el.style.color       = c.text;
                el.style.border      = '1px solid ' + c.border;
            });

            function mobileVis() {
                return window.innerWidth < 768 ? 1 : vis;
            }

            function getMax() {
                return Math.max(0, total - mobileVis());
            }

            function getSlideWidth() {
                var container = section.querySelector('.v2-testimonials-cards__container');
                var wrapWidth = container ? container.offsetWidth : section.offsetWidth;
                var mv = mobileVis();
                var gap = 16;
                return Math.floor((wrapWidth - (mv - 1) * gap) / mv);
            }

            function setSizes() {
                var sw = getSlideWidth();
                slides.forEach(function (s) {
                    s.style.width = sw + 'px';
                });
            }

            function goTo(idx) {
                var max = getMax();
                idx = Math.max(0, Math.min(idx, max));
                cur = idx;

                var sw = getSlideWidth();
                track.style.transform = 'translateX(-' + (cur * (sw + 16)) + 'px)';

                var mv = mobileVis();
                slides.forEach(function (s, i) {
                    s.setAttribute('aria-hidden', (i >= cur && i < cur + mv) ? 'false' : 'true');
                });

                dots.forEach(function (d, i) {
                    var active = i === cur;
                    d.classList.toggle('v2-testimonials-cards__dot--active', active);
                    d.setAttribute('aria-selected', active ? 'true' : 'false');
                    d.style.display = i <= getMax() ? '' : 'none';
                });

                if (prevBtn) prevBtn.disabled = cur === 0;
                if (nextBtn) nextBtn.disabled = cur >= getMax();
            }

            dots.forEach(function (dot) {
                dot.addEventListener('click', function () {
                    goTo(parseInt(dot.dataset.index, 10));
                });
            });

            if (prevBtn) prevBtn.addEventListener('click', function () { goTo(cur - 1); });
            if (nextBtn) nextBtn.addEventListener('click', function () { goTo(cur + 1); });

            // Touch swipe
            var touchStartX = null;
            track.addEventListener('touchstart', function (e) {
                touchStartX = e.touches[0].clientX;
            }, { passive: true });
            track.addEventListener('touchend', function (e) {
                if (touchStartX === null) return;
                var diff = touchStartX - e.changedTouches[0].clientX;
                if (Math.abs(diff) > 50) goTo(diff > 0 ? cur + 1 : cur - 1);
                touchStartX = null;
            }, { passive: true });

            // Keyboard
            section.addEventListener('keydown', function (e) {
                if (e.key === 'ArrowLeft')  goTo(cur - 1);
                if (e.key === 'ArrowRight') goTo(cur + 1);
            });

            // Resize
            var resizeTimer;
            window.addEventListener('resize', function () {
                clearTimeout(resizeTimer);
                resizeTimer = setTimeout(function () {
                    setSizes();
                    goTo(Math.min(cur, getMax()));
                }, 100);
            }, { passive: true });

            // Defer until paint so container has a real offsetWidth
            requestAnimationFrame(function () {
                setSizes();
                goTo(0);
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2TestimonialsCards);
    } else {
        initV2TestimonialsCards();
    }

})();

(function () {

    // v2-estimator — interactive project cost estimator
    //
    // EST-01: billing is per OPTION, resolved server-side, so one question can
    // mix a once-off build with a monthly retainer and produce two totals.
    // Self-contained: nothing here depends on backgrounds.js, which GATE-37
    // loads only on pages that use an animation.

    function fmtRand(n) {
        return 'R' + Math.round(n).toLocaleString('en-ZA');
    }

    function fmtRange(low, high) {
        return Math.round(low) === Math.round(high)
            ? fmtRand(low)
            : fmtRand(low) + ' – ' + fmtRand(high);
    }

    function collectSelection(section, data) {
        // Read state straight off the inputs — they are the source of truth, so
        // a click, a Space press and the server-rendered `checked` all agree.
        var sel = {};
        data.forEach(function (q) { sel[q.id] = q.multi ? [] : ''; });

        section.querySelectorAll('.v2-estimator__input').forEach(function (input) {
            if (!input.checked) return;
            var qid = input.dataset.qid;
            if (input.dataset.multi === '1') {
                (sel[qid] = sel[qid] || []).push(input.dataset.oid);
            } else {
                sel[qid] = input.dataset.oid;
            }
        });
        return sel;
    }

    function isActive(q, opt, sel) {
        return q.multi
            ? (sel[q.id] || []).indexOf(opt.id) >= 0
            : sel[q.id] === opt.id;
    }

    function updateResult(section, data, sel) {
        var onceLow = 0, onceHigh = 0, monthlyLow = 0, monthlyHigh = 0;
        // EST-07: accumulate DAYS, convert once. Rounding each option before
        // adding gives a larger and wrong answer — 3 + 7 + 14 days is
        // ceil(24 / 4) = 6 weeks, where rounding first gives 1 + 2 + 4 = 7.
        // Nothing is stored or compared in weeks anywhere in this function.
        var dLow = 0, dHigh = 0;
        var groups = [];      // one entry per selected option, with its own inclusions
        var anySelected = false;

        data.forEach(function (q) {
            q.options.forEach(function (opt) {
                if (!isActive(q, opt, sel)) return;
                anySelected = true;

                if (opt.billing === 'monthly') {
                    monthlyLow  += opt.priceLow;
                    monthlyHigh += opt.priceHigh;
                    // A retainer adds no delivery weeks — timeline is once-off only.
                } else {
                    onceLow  += opt.priceLow;
                    onceHigh += opt.priceHigh;
                    dLow  += opt.daysLow;
                    dHigh += opt.daysHigh;
                }

                if (opt.includes && opt.includes.length) {
                    groups.push({ label: opt.label, items: opt.includes });
                }
            });
        });

        var emptyEl   = section.querySelector('[data-est-empty]');
        var figuresEl = section.querySelector('[data-est-figures]');
        var hasMoney  = (onceLow + onceHigh + monthlyLow + monthlyHigh) > 0;

        // Empty state rather than "R0" when nothing is chosen or everything is free.
        if (emptyEl)   emptyEl.hidden   = anySelected && hasMoney;
        if (figuresEl) figuresEl.hidden = !(anySelected && hasMoney);

        var onceWrap = section.querySelector('[data-est-once-wrap]');
        var priceEl  = section.querySelector('[data-est-price]');
        if (onceWrap) onceWrap.hidden = !(onceLow > 0 || onceHigh > 0);
        if (priceEl)  priceEl.textContent = fmtRange(onceLow, onceHigh);

        var monthlyWrap = section.querySelector('[data-est-monthly-wrap]');
        var monthlyEl   = section.querySelector('[data-est-monthly]');
        if (monthlyWrap) monthlyWrap.hidden = !(monthlyLow > 0 || monthlyHigh > 0);
        if (monthlyEl)   monthlyEl.textContent = fmtRange(monthlyLow, monthlyHigh) + ' /mo';

        var tlWrap = section.querySelector('[data-est-timeline-wrap]');
        var tlEl   = section.querySelector('[data-est-timeline]');
        // The divisor is a business fact and lives in one place — PHP's
        // crafted_billable_days_per_week(), handed over as an attribute. Guarded
        // again on read because the DOM is not a trusted source.
        var perWeek = parseInt(section.dataset.estDaysPerWeek, 10);
        if (!isFinite(perWeek) || perWeek < 1) perWeek = 4;

        var wLow  = dLow  > 0 ? Math.ceil(dLow  / perWeek) : 0;
        var wHigh = dHigh > 0 ? Math.ceil(dHigh / perWeek) : 0;
        if (wLow > wHigh) { var swap = wLow; wLow = wHigh; wHigh = swap; }

        if (tlWrap) tlWrap.hidden = !(wLow > 0 || wHigh > 0);
        if (tlEl) {
            tlEl.textContent = 'Delivery: ' +
                // Wording must match crafted_estimator_timeline() in
                // inc/block-helpers.php exactly — the panel and the email are
                // fixtured against each other.
                (wLow === wHigh
                    ? wLow + (wLow === 1 ? ' week' : ' weeks')
                    : wLow + '–' + wHigh + ' weeks');
        }

        var includesEl = section.querySelector('[data-est-includes]');
        var dividerEl  = section.querySelector('[data-est-divider]');
        if (includesEl) {
            includesEl.innerHTML = groups.map(function (g) {
                var items = g.items.map(function (item) {
                    return '<li class="v2-estimator__include-item">' +
                        '<svg viewBox="0 0 24 24" aria-hidden="true"><polyline points="20 6 9 17 4 12"/></svg>' +
                        '<span></span></li>';
                }).join('');
                return '<div class="v2-estimator__include-group">' +
                    '<p class="v2-estimator__include-head"></p>' +
                    '<ul class="v2-estimator__include-list">' + items + '</ul>' +
                    '</div>';
            }).join('');

            // Text set via textContent, never interpolated into the HTML above.
            var heads = includesEl.querySelectorAll('.v2-estimator__include-head');
            var lists = includesEl.querySelectorAll('.v2-estimator__include-list');
            groups.forEach(function (g, i) {
                if (heads[i]) heads[i].textContent = g.label;
                if (!lists[i]) return;
                var spans = lists[i].querySelectorAll('.v2-estimator__include-item span');
                g.items.forEach(function (item, j) {
                    if (spans[j]) spans[j].textContent = item;
                });
            });
        }
        if (dividerEl) dividerEl.hidden = !groups.length;
    }

    function initV2Estimator() {
        var sections = document.querySelectorAll('.v2-estimator');
        if (!sections.length) return;

        sections.forEach(function (section) {
            if (section.dataset.v2Init) return;
            section.dataset.v2Init = '1';

            var data;
            try { data = JSON.parse(section.dataset.config || '[]'); } catch (e) { return; }
            if (!data || !data.length) return;

            function recalc() {
                updateResult(section, data, collectSelection(section, data));
            }

            section.querySelectorAll('.v2-estimator__input').forEach(function (input) {
                input.addEventListener('change', function () {
                    var qid   = input.dataset.qid;
                    var multi = input.dataset.multi === '1';
                    var none  = input.dataset.none === '1';

                    if (multi && input.checked) {
                        var peers = section.querySelectorAll(
                            '.v2-estimator__input[data-qid="' + qid + '"]'
                        );
                        peers.forEach(function (peer) {
                            if (peer === input) return;
                            // "None" clears everything else; picking anything else clears "None".
                            if (none || peer.dataset.none === '1') peer.checked = false;
                        });
                    }

                    // Radios cannot be unchecked by the browser, so allow a second
                    // activation to clear a single-select question.
                    recalc();
                });

                // EST-03: the second-click-to-clear handler that used to live
                // here is gone. It worked, but nothing on screen said it was
                // possible, so in practice only someone who tried it found it.
                // Single-select questions now carry a "None" option instead —
                // injected in the partial where the editor has not supplied one
                // — which is visible, keyboard-standard, and priced at zero
                // rather than treated as an absent answer.
            });

            // ── EST-02: payload + reveal ──────────────────────────────
            // Identifiers only. Prices are rebuilt server-side from ACF, so
            // nothing here can influence what is quoted.
            var postId   = section.dataset.estPost;
            var blockIdx = section.dataset.estBlock;

            function writePayload() {
                var field = section.querySelector('[data-est-payload]');
                if (!field || postId === undefined || blockIdx === undefined) return;

                var parts = [];
                data.forEach(function (q, qi) {
                    var chosen = [];
                    q.options.forEach(function (opt, oi) {
                        var input = section.querySelector(
                            '.v2-estimator__input[data-oid="' + opt.id + '"]'
                        );
                        if (input && input.checked) chosen.push(oi);
                    });
                    if (chosen.length) parts.push('q' + qi + ':' + chosen.join(','));
                });

                field.value = parts.length
                    ? 'p' + postId + ':b' + blockIdx + '|' + parts.join('|')
                    : '';
            }

            var revealBtn = section.querySelector('[data-est-reveal]');
            var capture   = revealBtn && document.getElementById(
                revealBtn.getAttribute('aria-controls')
            );

            if (revealBtn && capture) {
                revealBtn.addEventListener('click', function () {
                    var open = capture.hidden;
                    capture.hidden = !open;
                    revealBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
                    if (open) {
                        writePayload();
                        // Move focus in so keyboard users land on the form.
                        var first = capture.querySelector(
                            'input, textarea, select, button, [tabindex]'
                        );
                        if (first) first.focus();
                    }
                });
            }

            // Keep the payload current while the form is open.
            section.addEventListener('change', writePayload);

            // Server-rendered `checked` from is_default is already correct, so the
            // first paint needs no JS; this only syncs the panel to it.
            recalc();
            writePayload();
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2Estimator);
    } else {
        initV2Estimator();
    }

})();

(function () {

    // v2-client-logo-circles — marquee duplicate guard
    // PHP renders items twice; this adds more copies only if the
    // track is still shorter than 2x the container width.

    function initV2ClientLogoCircles() {
        var marquees = document.querySelectorAll('.v2-client-logo-circles__marquee');
        if (!marquees.length) return;

        marquees.forEach(function (marquee) {
            var wrap = marquee.closest('.v2-client-logo-circles__marquee-wrap');
            if (!wrap) return;

            requestAnimationFrame(function () {
                var wrapWidth    = wrap.offsetWidth;
                var marqueeWidth = marquee.scrollWidth;

                if (marqueeWidth < wrapWidth * 2) {
                    var origItems = Array.from(marquee.children);
                    origItems.forEach(function (item) {
                        marquee.appendChild(item.cloneNode(true));
                    });
                }
            });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2ClientLogoCircles);
    } else {
        initV2ClientLogoCircles();
    }

})();

(function () {

    // v2-rich-content — inline TOC smooth scroll + IntersectionObserver active tracking

    function initV2RichContent() {
        var blocks = document.querySelectorAll('.v2-rich-content');
        if (!blocks.length) return;

        blocks.forEach(function (block) {
            var tocLinks = Array.from(block.querySelectorAll('.v2-rich-content__toc-link'));
            var prose    = block.querySelector('.v2-rich-content__prose');
            if (!tocLinks.length || !prose) return;

            var headings = Array.from(prose.querySelectorAll('h2[id], h3[id]'));
            if (!headings.length) return;

            // ── Smooth scroll on TOC click ────────────────────
            tocLinks.forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    var target = document.getElementById(link.dataset.target);
                    if (!target) return;
                    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    setActive(link.dataset.target);
                });
            });

            // ── Active state management ───────────────────────
            function setActive(id) {
                tocLinks.forEach(function (link) {
                    link.classList.toggle('v2-rich-content__toc-link--active', link.dataset.target === id);
                });
            }

            // ── IntersectionObserver ──────────────────────────
            if ('IntersectionObserver' in window) {
                var observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(function (entry) {
                            if (entry.isIntersecting) {
                                setActive(entry.target.id);
                            }
                        });
                    },
                    {
                        rootMargin: '0px 0px -65% 0px',
                        threshold: 0,
                    }
                );
                headings.forEach(function (h) { observer.observe(h); });
            }

            // ── Scroll fallback — catches fast scrolls ────────
            var scrollTimer;
            window.addEventListener('scroll', function () {
                clearTimeout(scrollTimer);
                scrollTimer = setTimeout(function () {
                    var closest    = null;
                    var closestTop = Infinity;
                    headings.forEach(function (h) {
                        var top = h.getBoundingClientRect().top;
                        if (top >= 0 && top < closestTop) {
                            closestTop = top;
                            closest    = h;
                        }
                    });
                    if (closest) setActive(closest.id);
                }, 100);
            }, { passive: true });
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initV2RichContent);
    } else {
        initV2RichContent();
    }

})();
